import { Container } from 'react-bootstrap';

const AboutComp = () => {
    return (
        <div>
            <section>
                <Container>
                    <h1>About</h1>

                    <p>
                        Welcome to The One Shop, your ultimate destination to discover a wide range of quality products that cater to all your needs. We take pride in being your online shopping
                        partner, offering an unforgettable shopping experience and carefully curated products that meet the highest standards of quality.
                    </p>

                    <p>
                        At The One Shop, we understand that every consumer has diverse needs. Therefore, we are committed to providing various product categories with extensive choices, ranging from
                        fashion, beauty, electronics, home essentials, to sports gear. Every product we offer is meticulously selected to ensure the satisfaction and trust of our customers.
                    </p>

                    <p>
                        Security and safety in online transactions are our top priorities. We employ the latest technology to protect your personal information, allowing you to shop comfortably and
                        securely at The One Shop. With responsive customer service, our team is always ready to assist you with any questions or provide any assistance you may need.
                    </p>

                    <p>
                        The One Shop is also known for our commitment to sustainability. We collaborate with brands and manufacturers that uphold strong environmental principles, ensuring that our
                        offered products are not only of high quality but also environmentally friendly.
                    </p>

                    <p>
                        Inspired by the desire to be the go-to online store for your shopping needs, we continue to develop and enhance our services. With The One Shop, you are not just a customer but
                        also part of a community that values quality and integrity.
                    </p>

                    <p>Happy shopping at The One Shop, where quality, security, and customer satisfaction are our top priorities.</p>
                </Container>
            </section>
        </div>
    );
};

export default AboutComp;
